import {Component, OnInit, ViewChild} from '@angular/core';
import {GlobalService} from '../../../global.service';
import {Title} from '@angular/platform-browser';
import {MatSidenav} from '@angular/material/sidenav';

@Component({
  selector: 'app-tecno-cup-ksa',
  templateUrl: './tecno-cup-ksa.component.html',
  styleUrls: ['./tecno-cup-ksa.component.scss']
})
export class TecnoCupKsaComponent implements OnInit {
  opened: boolean = false;
  @ViewChild('sidenav') sidenav: MatSidenav;
  reason = ''

  toggle() {
    this.opened = !this.opened;
  }
  navigateTo() {
    this.opened = false;

  }
  close(reason: string) {
    this.reason = reason;
    this.sidenav.close();
  }
  loading = false
  constructor(public globalService:GlobalService , private titleService: Title) {
    this.titleService.setTitle('tecno-pubg-mobile-cup-2-saudi-arabia')

  }

  ngOnInit() {
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.globalService.customLang = require('./lang/' + localStorage.getItem('language') + '.json');
        this.globalService.langChosen = localStorage.getItem('language');
      } else {
        localStorage.setItem('language' , 'ar')
        this.globalService.customLang = require('./lang/' + localStorage.getItem('language') + '.json');
        this.globalService.langChosen = localStorage.getItem('language');

      }
    }


  }
  languageChange(value) {
    console.log(value)
      this.globalService.langChosen = value;
      this.globalService.customLang = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);
    console.log(this.globalService.langChosen)

  }
}
